import Logo from "./Logo.png";
import Apk from "./Apk.png";
import Hero from "./hero.png";
import Appstore from "./app-store.png";
import Googlestore from "./google-play.png";
import Banner1 from "./Banner1.png";
import Banner2 from "./Banner2.png";
import Banner3 from "./Banner3.png";
import Banner4 from "./Banner4.png";
import FemaleCategory from "./FemaleCategory.png";
import MenCategory from "./MenCategory.png";
import KidsCategory from "./KidsCategory.png";
import SubScription from "./Subscription.png";

export {
  Logo,
  Apk,
  Hero,
  Appstore,
  Googlestore,
  Banner1,
  Banner2,
  Banner3,
  Banner4,
  FemaleCategory,
  MenCategory,
  KidsCategory,
  SubScription,
};
